import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import donationHeaderProdigalChildren from "../../../../src/content/prodigal-children/donationHeader";
import * as React from 'react';
export default {
  NewNamesForm,
  donationHeaderProdigalChildren,
  React
};